import S from 'common/service/sanctuary';
import { scopedType } from './type';

const factory$ = (namespace, reducer) =>
  (state, action) => S.maybe(
    typeof state === 'undefined' ? reducer(undefined, action) : state,
    type => reducer(state, {
      ...action,
      type,
    }),
    S.stripPrefix(scopedType(namespace, ''), action.type),
  );

export const factory = S.curry2(factory$);

export default factory;
